/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of MadeInStoreClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  PagedData_1OfMadeInStoreItem,
  SuccessResponse_1OfList_1OfItemRecipeSummary,
  SuccessResponse_1OfGetItemsResponseDto,
  MadeInStoreItemRequest,
  CreateMadeInStoreItemRequestDto,
  GetItemsRequestDto,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockMadeInStoreItems = [
  { id: 1, itemNumber: 'MIS001', description: 'Fresh Latte', quantity: 25, date: '2025-12-12' },
  { id: 2, itemNumber: 'MIS002', description: 'Cappuccino', quantity: 18, date: '2025-12-12' },
  { id: 3, itemNumber: 'MIS003', description: 'Fresh Sandwich', quantity: 12, date: '2025-12-12' },
];

/* ---- Mocked Client Implementation ---- */

import { IMadeInStoreClient } from '../../interfaces';
export class MadeInStoreClientMocked implements IMadeInStoreClient {
  constructor(baseUrl?: string) {}

  async madeinstoreGET(
    search?: string,
    storeNumber?: string,
    skip?: number,
    take?: number,
    cancelToken?: CancelToken
  ): Promise<PagedData_1OfMadeInStoreItem> {
    await delay();
    let filtered = [...mockMadeInStoreItems];
    if (search) {
      filtered = filtered.filter(
        (i) =>
          i.itemNumber.toLowerCase().includes(search.toLowerCase()) ||
          i.description.toLowerCase().includes(search.toLowerCase())
      );
    }
    const start = skip || 0;
    const end = start + (take || 10);
    return {
      data: filtered.slice(start, end),
      totalCount: filtered.length,
      skip: start,
      take: end - start,
    } as PagedData_1OfMadeInStoreItem;
  }

  async madeinstorePOST(body?: MadeInStoreItemRequest, cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfItemRecipeSummary> {
    await delay();
    return successResponse([
      { itemNumber: 'COMP001', description: 'Milk Used', quantity: 2.5 },
      { itemNumber: 'COMP002', description: 'Coffee Used', quantity: 0.5 },
    ]) as SuccessResponse_1OfList_1OfItemRecipeSummary;
  }

  async create(body?: CreateMadeInStoreItemRequestDto, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body) {
      mockMadeInStoreItems.push({
        id: mockMadeInStoreItems.length + 1,
        itemNumber: body.itemNumber || `MIS00${mockMadeInStoreItems.length + 1}`,
        description: body.description || 'New Item',
        quantity: 1,
        date: new Date().toISOString().split('T')[0],
      });
    }
  }

  async storeItems(body?: GetItemsRequestDto, cancelToken?: CancelToken): Promise<SuccessResponse_1OfGetItemsResponseDto> {
    await delay();
    return successResponse({
      items: mockMadeInStoreItems,
      totalCount: mockMadeInStoreItems.length,
    }) as SuccessResponse_1OfGetItemsResponseDto;
  }

  // ====== Auto-generated stub methods ======




}
